import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CarouselModule } from '@epicuro-next/ataraxia/carousel';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { MediaModule } from '@epicuro-next/ataraxia/media';

import { MediaLightboxComponent } from './components/media-lightbox/media-lightbox.component';
import { MediaLightboxDirective } from './directives/media-lightbox/media-lightbox.directive';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    MediaModule,
    CarouselModule,
    ImageModule,
    IconsModule,
  ],
  declarations: [MediaLightboxDirective, MediaLightboxComponent],
  exports: [MediaLightboxDirective, MediaLightboxComponent],
})
export class MediaLightboxModule {}
